import PhotoSwipeLightbox from "photoswipe/lightbox";
import PhotoSwipeDynamicCaption from "photoswipe-dynamic-caption-plugin";

export default class PhotoSwipeGallery {
  constructor(selector) {
    this.selector = selector;
    this._init();
  }

  _init() {
    const el = document.querySelector(this.selector);
    if (!el) return;

    const lightbox = new PhotoSwipeLightbox({
      gallery: this.selector,
      children: ".imgs__splide-slide-link",
      pswpModule: () => import("photoswipe"),
      paddingFn: (viewportSize) => {
        if (window.innerWidth < 768) {
          return {
            top: 16,
            bottom: 16,
            left: 16,
            right: 16,
          };
        }

        return {
          top: 30,
          bottom: 30,
          left: 70,
          right: 70,
        };
      },
    });

    new PhotoSwipeDynamicCaption(lightbox, {
      type: window.innerWidth >= 768 ? "below" : "auto",
      captionContent: (slide) => {
        return slide.data.element?.dataset.caption || "";
      },
    });

    lightbox.init();
  }
}
